export function isObject(item: any): item is Record<string, any> {
  return typeof item === 'object' && item !== null && !Array.isArray(item);
}

export function isPlainObject(item: any): item is Record<string, any> {
  return (
    Object.prototype.toString.call(item) === '[object Object]' &&
    (item.constructor === Object || item.constructor === undefined)
  );
}

export function deepMergeCore<T extends Record<string, any>, U extends Record<string, any>>(
  target: T,
  source: U
) {
  target = { ...target };
  for (const key in source) {
    const targetValue = target[key];
    const sourceValue = source[key];
    if (isPlainObject(targetValue) && isPlainObject(sourceValue)) {
      target[key] = deepMergeCore(targetValue, sourceValue);
    } else {
      target[key] = sourceValue as any;
    }
  }
  return target as U & T;
}

export function deepMerge<T extends Record<string, any>, U>(target: T, source: U): T & U {
  if (isObject(target) && isPlainObject(source)) {
    return deepMergeCore(target, source);
  }
  return source as T & U;
}

export function safeJsonParse<T>(string: string, defaultValue: T) {
  try {
    return JSON.parse(string) as T;
  } catch (_) {
    return defaultValue;
  }
}
